import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgEmail(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="6 10 50 39"
      fill="none"
      {...props}
    >
      <path
        stroke={props.primaryColor}
        strokeWidth={2}
        d="M10.02 13h36.368c.272 0 .532.108.723.298s.297.445.297.71v28.126c0 .266-.106.522-.297.712-.19.19-.45.297-.723.297H10.02c-.273 0-.533-.108-.724-.297A1 1 0 0 1 9 42.134V14.009c0-.266.106-.521.297-.711.19-.19.451-.298.723-.298Zm35.366 2.116L29.546 26.93a2.245 2.245 0 0 1-2.684 0l-15.84-11.813-1.597-1.192v28.808h37.558V13.924zm-33.54.096 15.275 11.39a1.81 1.81 0 0 0 2.166 0l15.275-11.39 2.415-1.8H9.432z"
      />
      <path
        fill={props.secondaryColor}
        fillRule="evenodd"
        d="m49.211 45.697.279 1.547q-1.74.573-3.548.572-3.328 0-5.414-1.938-2.222-2.049-2.222-5.424 0-3.184 2.106-5.232 2.174-2.1 5.51-2.1 3.02 0 4.991 1.627a5.6 5.6 0 0 1 1.53 2Q53 37.972 53 39.45q0 2.34-1.298 3.736-1.164 1.246-2.625 1.246-1.56 0-1.712-1.417-.962 1.417-2.597 1.417-1.317 0-2.086-.764-.837-.823-.837-2.26 0-.954.38-1.873a4.8 4.8 0 0 1 1.053-1.592q1.278-1.275 3.289-1.275 1.519 0 2.837.492l-.645 4.178a6.5 6.5 0 0 0-.096.894q0 .693.587.693.768 0 1.375-.934.74-1.135.74-2.692 0-2.139-1.442-3.334-1.597-1.316-3.962-1.316-1.827 0-3.328.904a5.44 5.44 0 0 0-2.125 2.31q-.567 1.185-.567 2.632 0 2.741 1.904 4.348 1.673 1.417 4.25 1.417 1.472 0 3.116-.563m-1.817-7.492q-.49-.141-.798-.141-.549 0-1.087.286-.54.287-.923.789a3.6 3.6 0 0 0-.789 2.27q0 .702.346 1.11.346.405.943.406.865 0 1.433-.743.297-.382.47-1.477z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default SvgEmail;
